import React from "react"
import { styled } from "@mui/material/styles"

import { GatsbyImage } from "gatsby-plugin-image"
import { Link } from "gatsby"
import { getEntityUrl, getAccessoryIcon } from "../../util"

import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import {EntityListItems} from "../../components/List";
import WmaInlineListItemLayout from "../wma-list/list";
import {findListItemRole} from "../../repository/EntityRepository";

const PREFIX = "List"

const classes = {
  listItem: `${PREFIX}-listItem`,
  listLink: `${PREFIX}-listLink`,
  listImg: `${PREFIX}-listImg`,
  titleDiv: `${PREFIX}-titleDiv`,
  titleFlex: `${PREFIX}-titleFlex`,
  title1: `${PREFIX}-title1`,
  title2: `${PREFIX}-title2`,
  title3: `${PREFIX}-title3`,
  numCode: `${PREFIX}-numCode`,
  playButton: `${PREFIX}-playButton`
}

const Root = styled("ul")(({ theme }) => ({
  listStyleType: "none",
  margin: "0",
  marginTop:"10px",
  padding: 0,
  borderTop: '1px solid #ddd',


  [`& .${classes.listItem}`]: {
    textDecoration: "none",
    position: "relative",
    cursor: "pointer",
    padding: "8px 0 8px 8px",
    color: theme.palette.primary.main,
    background: theme.palette.mode === "light" ? "#ffffff" : "#333",
    borderBottom: '1px solid',
    borderColor: theme.palette.mode === "light" ? "#ddd" : "#737373",
    listStyle: "none",
    display: "flex",
    flexDirection:"row",
    justifyContent: "flex-start",
    minHeight: "48px",
    margin: "0",
    overflow: "hidden",
    alignItems: "center",
  },

  [`& .${classes.listLink}`]: {
    textDecoration: "none"
    //   color: '#000',
  },

  [`& .${classes.listImg}`]: {
    width: "100px",
    height: "100px",
    flexShrink: 0,
    border: "1px solid #ddd"
  },


  [`& .${classes.titleDiv}`]: {
    width: "100%",
    overflow: "hidden",
    padding: "0px 28px 0px 0px"
  },

  [`& .${classes.titleFlex}`]: {
    display: "flex",
    flexGrow: "1",
    alignItems: "center",
    position: "relative",
    minHeight: "60px",
  },

  [`& .${classes.title1}`]: {
    fontSize: '1.2em',
    textTransform: 'none',
    marginBottom: 0,
    lineHeight: 1.15,
    fontWeight: 600,
  },

  [`& .${classes.title2}`]: {
    fontSize: '1em',
    lineHeight: 1.2,
    marginTop: 4,
    paddingRight: 20,
  },

  [`& .${classes.title3}`]: {
    fontSize: "0.9em",
    marginBottom: "0px",
    marginTop: "2px",
    fontWeight: "normal"
  },

  [`& .${classes.numCode}`]: {
    position: 'absolute',
    right: 8,
    bottom: 6,
    fontSize: '0.9rem',
    fontWeight: 600,
    display: 'block',
  },

  [`& .${classes.playButton}`]: {
    position: "absolute",
    right: "6px",
    top: "50%",
    transform: "translateY(-50%)"
  }
}))

const ListItemLayout = ({ entity, title1, title2, title3, numCode, pageContext, sublistRole, image, associatedEntity, oaiRole }) => {
  const { defaultLocale } = pageContext;
  const AccessoryIcon = getAccessoryIcon({ defaultIcon: ArrowForwardIosIcon, role: findListItemRole(entity)});

  return (
        <Link to={getEntityUrl({ entity, defaultLocale })} className={classes.listLink}>
          <li className={classes.listItem}>
            {image && <GatsbyImage className={classes.listImg} image={image} alt={title1} layout="fullWidth"/>}
            <div className={classes.titleFlex}>
              <div className={classes.titleDiv}>
                <div className={classes.title1}>{title1}</div>
                <div className={classes.title2}>{title2}</div>
                <div className={classes.title3}>{title3}</div>
                <div className={classes.playButton}>
                  <AccessoryIcon color="secondary" fontSize="small" />
                </div>
              </div>
            </div>
            <div className={classes.numCode}>{numCode}</div>
          </li>
        </Link>
  )
}

const List = ({ entity, pageContext }) => {
  return (
      <Root>
        <EntityListItems entity={entity} pageContext={pageContext} listItemLayout={ListItemLayout} inlineListHeadlineLayout={WmaInlineListItemLayout} />
      </Root>
  );
};

export default List
